export function isLocalhost() {
  const hostname = window.location.hostname;

  return hostname === 'localhost' || hostname === '127.0.0.1';
}
